import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=62a5af85&scoped=true&"
import script from "./radio.js?vue&type=script&lang=js&"
export * from "./radio.js?vue&type=script&lang=js&"
import style0 from "./radio.scss?vue&type=style&index=0&id=62a5af85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a5af85",
  null
  
)

export default component.exports